import { render } from "./AllDevicePage.vue?vue&type=template&id=fbd1fdb2&ts=true"
import script from "./AllDevicePage.vue?vue&type=script&lang=ts"
export * from "./AllDevicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__